<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 18V12C3 10.9 3.9 10 5 10H19C20.1 10 21 10.9 21 12V18"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 18H21"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M6 10V8C6 6.9 6.9 6 8 6H16C17.1 6 18 6.9 18 8V10"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="8" cy="13" r="1.5" :stroke="color" stroke-width="1.5" />
    <circle cx="16" cy="13" r="1.5" :stroke="color" stroke-width="1.5" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
